import { Grid } from '@mui/material';

import { InitialCausalityDataProps } from './props';
import { useInitialCausalityData } from './hook';

import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

import { formatParams } from '../../../../../../shared/utils/params';

export const InitialCausalityData = (props: InitialCausalityDataProps) => {
    const {
        formik,
        products,
        motives,
        submotives1,
        submotives2,
        submotives3,
        submotives4,
        typesPqr,
        typesComplaint,
    } = useInitialCausalityData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={3} md={4}>
                <FieldText
                    label={formik.values.name ?? 'Nombre'}
                    name="name"
                    size="small"
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(products)}
                    label="Producto"
                    name="product"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.product}
                    errors={formik.errors.product}
                    value={formik.values.product}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('product', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typesPqr)}
                    label="Tipo de Pqr"
                    name="typePqr"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typePqr}
                    errors={formik.errors.typePqr}
                    value={formik.values.typePqr}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typePqr', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(motives)}
                    label="Motivo"
                    name="motive"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.motive}
                    errors={formik.errors.motive}
                    value={formik.values.motive}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('motive', value)
                    }
                />
            </Grid>
            {submotives1.length > 0 && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(submotives1)}
                        label="Submotivo 1"
                        name="submotive1"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.submotive1}
                        errors={formik.errors.submotive1}
                        value={formik.values.submotive1}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('submotive1', value)
                        }
                    />
                </Grid>
            )}
            {submotives2.length > 0 && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(submotives2)}
                        label="Submotivo 2"
                        name="submotive2"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.submotive2}
                        errors={formik.errors.submotive2}
                        value={formik.values.submotive2}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('submotive2', value)
                        }
                    />
                </Grid>
            )}
            {submotives3.length > 0 && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(submotives3)}
                        label="Submotivo 3"
                        name="submotive3"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.submotive3}
                        errors={formik.errors.submotive3}
                        value={formik.values.submotive3}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('submotive3', value)
                        }
                    />
                </Grid>
            )}
            {submotives4.length > 0 && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(submotives4)}
                        label="Submotivo 4"
                        name="submotive4"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.submotive4}
                        errors={formik.errors.submotive4}
                        value={formik.values.submotive4}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('submotive4', value)
                        }
                    />
                </Grid>
            )}
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Categoria"
                    name="category"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.category}
                    errors={formik.errors.category}
                    value={formik.values.category}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Proceso"
                    name="process"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.process}
                    errors={formik.errors.process}
                    value={formik.values.process}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Subproceso"
                    name="subprocess"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.subprocess}
                    errors={formik.errors.subprocess}
                    value={formik.values.subprocess}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="NO. Riesgo"
                    name="riskId"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.riskId}
                    errors={formik.errors.riskId}
                    value={formik.values.riskId}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Riesgo"
                    name="risk"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.risk}
                    errors={formik.errors.risk}
                    value={formik.values.risk}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Consecuencia"
                    name="consequence"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.consequence}
                    errors={formik.errors.consequence}
                    value={formik.values.consequence}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Impacto del riesgo"
                    name="riskImpact"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.riskImpact}
                    errors={formik.errors.riskImpact}
                    value={formik.values.riskImpact}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Motivo de reclamación SFC"
                    name="sfcMotiveClaim"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.sfcMotiveClaim}
                    errors={formik.errors.sfcMotiveClaim}
                    value={formik.values.sfcMotiveClaim}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Subcuenta SFC"
                    name="sfcSubaccount"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.sfcSubaccount}
                    errors={formik.errors.sfcSubaccount}
                    value={formik.values.sfcSubaccount}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Motivo [SECTOR - FASECOLDA]"
                    name="sfcMotive"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.sfcMotive}
                    errors={formik.errors.sfcMotive}
                    value={formik.values.sfcMotive}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Submotivo [SECTOR - FASECOLDA]"
                    name="sfcSubmotive"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.sfcSubmotive}
                    errors={formik.errors.sfcSubmotive}
                    value={formik.values.sfcSubmotive}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Código motivo quejas sector SFC(Nuevo)"
                    name="sfcMotiveIdComplaint"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.sfcMotiveIdComplaint}
                    errors={formik.errors.sfcMotiveIdComplaint}
                    value={formik.values.sfcMotiveIdComplaint}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Código motivo quejas sector SFC(Anterior)"
                    name="sfcMotiveIdComplaintOld"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.sfcMotiveIdComplaintOld}
                    errors={formik.errors.sfcMotiveIdComplaintOld}
                    value={formik.values.sfcMotiveIdComplaintOld}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typesComplaint)}
                    label="Tipo de queja"
                    name="typeComplaint"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typeComplaint}
                    errors={formik.errors.typeComplaint}
                    value={formik.values.typeComplaint}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typeComplaint', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre Motivo de Queja SFC"
                    name="motiveName"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.motiveName}
                    errors={formik.errors.motiveName}
                    value={formik.values.motiveName}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Descripción Motivo de Quejas SFC"
                    name="motiveDescription"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.motiveDescription}
                    errors={formik.errors.motiveDescription}
                    value={formik.values.motiveDescription}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() =>
                        formik.setFieldValue('active', !formik.values.active)
                    }
                    onBlur={formik.handleBlur}
                    isCheckMode={true}
                />
            </Grid>
        </Grid>
    );
};
